import { apiPaths, getBase2 } from "modules/platform-components/api-integration-util";
import { getUserDetails } from "modules/platform-components/utils/shared-data.service";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

let currentUser = JSON.parse(localStorage.getItem("user"));

function WowzaMeeting() {
  let { id } = useParams();

  const getLiveClasses = () => {
    getBase2(`${apiPaths.getLiveClassesById}?liveClassId=${id}`)
      .then((res) => {
        const data = res.result
        sendMessageToIframe({
          liveClassId: data.liveClassId, liveStreamingId: data.liveStreamingId, streamAppName: data.streamAppName, tenantId: getUserDetails().tenantId, email: getUserDetails().email, token: getUserDetails().token
        })
      })
      .catch((ele) => {});
  };

  useEffect(() => {
    getLiveClasses();
   
  }, [getLiveClasses]);

  const sendMessageToIframe = (data) => {
    // Get a reference to the iframe
    const iframe = document.querySelector('iframe');
    console.log('iframe: ', data);

    // Send the message to the iframe
    setTimeout(() => {
      iframe.contentWindow.postMessage(data, '*');
    }, 2000)
  };



  return (
    <div className="main">
      <iframe
        src={process.env.REACT_APP_ARISE_LIVE_STREAM}
        style={{ width: "100%", height: "100vh", border: "none" }}
        allow="camera; microphone;display-capture;"
      ></iframe>
    </div>
  );
}

export default WowzaMeeting;
